<template>
  <!-- eslint-disable vue/attribute-hyphenation  -->
  <NewBsBox
    :bs="{
      'cmp.calendar': 'wrapper',
      ...bs,
    }"
  >
    <CalendarHead
      :viewMode="viewMode"
      :current="current"
      :onPrev="e => handleBase('subtract')"
      :onNext="e => handleBase('add')"
      :showPrev="showPrev"
      :showNext="showNext"
      :setViewMode="setViewMode"
      :handleBase="handleBase"
    />
    <Divider
      :bs="dividerBs"
      hair-line
    />
    <CalendarBody
      :viewMode="viewMode"
      :current="current"
      :selected="selected"
      :startDay="startDay"
      :endDay="endDay"
      :setBase="setBase"
      :setViewMode="setViewMode"
      :disableDay="disableDay"
      :disableMonth="disableMonth"
      :disableYear="disableYear"
      :handleMouseOver="handleMouseOver"
      :onClickDay="onClickDay"
      :monthIndex="monthIndex"
    />
  </NewBsBox>
</template>

<script lang="ts">
  import { defineComponent, PropType, ref } from 'vue'
  import { dayjs } from '@xhs/yam-beer/utils/dayjs'
  import type { Dayjs } from 'dayjs'
  import { ViewModeType } from '@xhs/yam-beer/cmp/constants'
  import NewBsBox from '@xhs/yam-beer/cmp/primitive/NewBsBox'
  import Divider from '@xhs/yam-beer/cmp/common/Divider/Divider.vue'
  import CalendarHead from './Header'
  import CalendarBody from './Body.vue'

  export default defineComponent({
    name: 'CalendarContainer',
    components: {
      Divider,
      CalendarHead,
      CalendarBody,
      NewBsBox,
    },
    props: {
      /**
       * dayjs object
       */
      startDay: {
        type: Object as PropType<Dayjs>,
      },
      /**
       * dayjs object
       */
      endDay: {
        type: Object as PropType<Dayjs>,
      },
      selected: {
        type: Array,
        default: () => ([]),
      },
      /**
       * Function
       * params day,start,end
       */
      disableDay: Function,
      disableMonth: Function,
      disableYear: Function,
      handleMouseOver: Function,
      onClickDay: Function,
      bs: {
        type: Object,
        default: () => ({}),
      },
      dividerBs: {
        type: Object,
        default: () => ({}),
      },
      /**
       * dayjs object
       */
      current: {
        type: Object as PropType<Dayjs>,
        default: dayjs(),
      },
      /**
       * dayjs object
       */
      base: {
        type: Object as PropType<Dayjs>,
        required: true,
      },
      setBase: {
        type: Function,
        required: true,
      },
      defaultMode: {
        type: String as PropType<ViewModeType>,
        default: 'd',
      },
      onSetViewMode: {
        type: Function,
      },
      showPrev: Boolean,
      showNext: Boolean,
      onChange: Function,
      monthIndex: Number,
    },
    setup(props) {
      const viewMode = ref(props.defaultMode)

      const setViewMode = (mode: ViewModeType, nextBase: Dayjs) => {
        let returnMode = mode
        if (props.onSetViewMode) {
          returnMode = props.onSetViewMode(mode, nextBase)
        }
        viewMode.value = returnMode
      }
      const handleBase = (method: 'subtract'|'add', yearStep = false) => {
        const date = dayjs(props.base)
        if (viewMode.value === 'y') {
          props.setBase(date[method](10, 'year'))
        } else if (yearStep || viewMode.value === 'm') {
          props.setBase(date[method](1, 'year'))
        } else {
          props.setBase(date[method](1, 'month'))
        }
      }
      return {
        viewMode,
        setViewMode,
        handleBase,
      }
    },
  })
</script>
